export type Category = 'Billing' | 'Technical' | 'Account' | 'Shipping' | 'Feature request' | 'Other';
export type Priority = 'Urgent' | 'High' | 'Medium' | 'Low';
export type TicketStatus = 'new' | 'drafted' | 'resolved';
export type AIModelId = 'gpt-6-luna' | 'claude-sonnet-5';
export interface AIModelOption {id: AIModelId; provider: 'openai' | 'anthropic'; label: string}
export interface AIModelSettings {selected_model_id: AIModelId; models: AIModelOption[]}
export interface Citation { id: string; title: string; excerpt: string; }
export interface Ticket {
  id: string; number: number; subject: string; message: string; source: string;
  status: TicketStatus; category: Category; priority: Priority; language: string;
  next_action: string; draft: string; citations: Citation[]; needs_human: boolean;
  approved: boolean; feedback: 'up' | 'down' | null; feedback_note: string;
  is_sample: boolean; created_at: string; updated_at: string; ai_error: string | null;
  triage_model_id?: AIModelId | null; draft_model_id?: AIModelId | null;
}
export interface Knowledge { id: string; title: string; content: string; category: Category; active: boolean; is_sample: boolean; format: string; created_at: string; updated_at: string; }
export interface GmailStatus { connected: boolean; configured: boolean; account: string | null; last_sync: string | null; auto_sync: boolean; error: string | null; redirect_uri: string; }
export interface SyncResult { imported: number; failed: number; tickets: Ticket[]; last_sync: string; warning: string | null; }
export type SyncAcknowledgement = Pick<SyncResult, 'imported'> & Partial<Omit<SyncResult, 'imported'>>;
export interface OAuthStartResult { url: string; }
export type TicketFilter = TicketStatus | 'all';
export interface InboxFilters {
  status: TicketFilter; query: string; priority: Priority | 'all'; category: Category | 'all'; mobileDetail: boolean;
}
export type TicketCounts = Record<TicketFilter, number>;
export type KnowledgeMode = 'text' | 'upload';
export interface KnowledgeForm { title: string; content: string; category: Category; }
export interface UploadProgress {phase: 'uploading' | 'processing'; percent: number | null}
export type SettingsAction = 'samples' | 'workspace' | null;
export type GmailOperation = 'connect' | 'sync' | 'disconnect' | 'settings' | null;
export type FeedbackTicket = Ticket & {feedback: 'up' | 'down'};
export const categories: Category[] = ['Billing', 'Technical', 'Account', 'Shipping', 'Feature request', 'Other'];
export const priorities: Priority[] = ['Urgent', 'High', 'Medium', 'Low'];